import React, { Component } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { SlPageTitle, SlSectionTitle, SlSectionLabel, SlFormEntryRow, TextInput, SlButton } from '../editors'
import { metadataService, newLoanStepperService, workflowService, ServiceUtil, SessionService } from "../../_services"
import { connect } from "react-redux";
import validator from 'validator';
import zxcvbn from 'zxcvbn';
import { registrationActions } from "../../_actions";
import Stepper from "./Stepper";

class SignUpCreatePassword extends Component {
    static displayName = SignUpCreatePassword.name;

    constructor(props) {
        super(props);
        this.state = {
            formValue: {
                newPassword: this.props.password + '',
                confirmPassword: this.props.confirmPassword + '',
            },
            formError: false,
            steps: [],
            currentStep: 0,
            pageText: '',
        }

        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSetState = this.handleSetState.bind(this);
    }
    componentDidMount() {

        let workflowData = workflowService.getCurrentWorkflowStepData();

        if (workflowData && workflowData.workflowId) {
            this.setState({
                steps: newLoanStepperService(workflowData.workflowId),
                currentStep: workflowData.currentStepperStep,
            });
        }

        // ServiceUtil.isBusinessHours().then(isBusinessHours => {
        //     let current = new Date();
        //     let submitDate = `${current.getMonth() + 1}/${current.getDate()}/${current.getFullYear()}`;
        //     //var theText = "";
        //     //if (isBusinessHours && isBusinessHours === true) {
        //     //    theText = metadataService.getMessage("WhatToExpectBusinessHours", submitDate);
        //     //}
        //     //else {
        //     //    theText = metadataService.getMessage("WhatToExpectAfterBusinessHours", submitDate);
        //     //}  
        //     let theText = this.props.existingCustomer ?  metadataService.getMessage("WhatToExpectGenericExisting") : metadataService.getMessage("WhatToExpectGeneric");
        //     this.setState({ pageText: theText });
        // });
    }

    handleInput = ({ target: { name, value } }) => {
        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };

        this.handleSetState({ formValue });
    };

    handleSetState(newState) {
        let finalState = { ...this.state, ...newState }
        newState.formError = this.isStateValid(finalState);
        this.setState(newState);
    }

    handleSubmit = () => {
        const { dispatch } = this.props;
        let formError = this.isStateValid(this.state);

        if (!formError) {
            let passwords = {
                password: this.state.formValue.newPassword,
                confirmPassword: this.state.formValue.confirmPassword
            };
            const personalInfo = SessionService.getPersonalInfo();
            let emailConfirmation = {
                codeToEmail: this.props.email ? this.props.email : personalInfo.email
            };

            dispatch(registrationActions.handleSendEmailCodeRequest(emailConfirmation, passwords));
        }
    }

    getPreapprovedHeader(requestedAmount, approvedAmount) {
        if (approvedAmount >= requestedAmount) {
            return metadataService.getMessage("ApplicationPreapprovedCongratulations", this.props.preapprovedAmount.toFixed(2))
        } else {
            return metadataService.getMessage("ApplicationPreapproved", this.props.preapprovedAmount.toFixed(2));
        }
    }

    isStateValid(newState) {
        let passwordStrengthScore = zxcvbn(newState.formValue.newPassword + '');

        //0 # too guessable: risky password. (guesses < 10 ^ 3)
        //1 # very guessable: protection from throttled online attacks. (guesses < 10 ^ 6)
        //2 # somewhat guessable: protection from unthrottled online attacks. (guesses < 10 ^ 8)
        //3 # safely unguessable: moderate protection from offline slow - hash scenario. (guesses < 10 ^ 10)
        //4 # very unguessable: strong protection from offline slow - hash scenario. (guesses >= 10 ^ 10) 

        //let passwordComplexityError = (passwordStrengthScore.score <= 2); 
        let isPasswordEmpty = validator.isEmpty(newState.formValue.newPassword);
        let confirmPasswordError = ((newState.formValue.newPassword !== newState.formValue.confirmPassword));
        let isPasswordWeak = !metadataService.checkPasswordComplexity(newState.formValue.newPassword);
        let isPasswordInvalid = true;

        if (isPasswordEmpty || confirmPasswordError || isPasswordWeak) {
            isPasswordInvalid = true;
        } else {
            isPasswordInvalid = false;
        }

        return isPasswordInvalid;
    }

    render() {
        let pageName = this.props.existingCustomer ? "SetPassword" : "ApplicationReceived";
        let pageText = this.props.existingCustomer ? "" : metadataService.getMessage("WhatToExpectGeneric");

        if (this.props.preapprovedAmount > 0) {
            pageText = "";
        }

        return (
            <div className="SignUpCreatePassword">
                {this.props.steps.length > 0 && (
                    <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />
                )}

                <SlFormEntryRow>
                    {this.props.preapprovedAmount > 0 ?
                        <h1 className='text-center Page-Title'>{this.getPreapprovedHeader(this.props.requestedAmount, this.props.preapprovedAmount)}</h1>
                        : <SlPageTitle pageName={pageName} />
                    }
                </SlFormEntryRow>
                <SlFormEntryRow>
                    <hr />
                </SlFormEntryRow>
                <Card>
                    <CardBody className="pt-0">
                        <SlSectionLabel sectionName={ this.props.preapprovedAmount > 0 ? "PasswordPreapproved_Label" : "Password_Label"} centered={false} className="password-label"/>
                        <SlFormEntryRow>
                            <TextInput
                                name="NewPassword"
                                onChange={this.handleInput}
                                type="password"
                                value={this.state.formValue.newPassword}
                            />
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            <TextInput
                                name="ConfirmPassword"
                                onChange={this.handleInput}
                                type="password"
                                value={this.state.formValue.confirmPassword}
                            />
                        </SlFormEntryRow>
                    </CardBody>
                </Card>
                <SlFormEntryRow>
                    <p className="passwordHelpText">
                        {metadataService.getMessage("PasswordRequirements")}
                    </p>
                </SlFormEntryRow>
                <Card>
                    <CardBody>
                        <SlFormEntryRow>

                            <div dangerouslySetInnerHTML={{ __html: pageText }} />

                        </SlFormEntryRow>
                    </CardBody>
                </Card>
                <SlFormEntryRow>
                    <div className="text-center">
                        <SlButton name="Next" size="lg" onClick={this.handleSubmit} disabled={this.state.formError || this.props.isBusy} />
                    </div>
                </SlFormEntryRow>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;
    const { confirmationSummaryScreen, error, password, confirmPassword, completedSteps, createPasswordSuccess, email, confirmEmail, isBusy } = state.registration;
    const { steps, currentStep } = state.users;
    const existingCustomer = state.registration.existingCustomer || JSON.parse(sessionStorage.getItem("existingCustomer"));

    return {
        loggedIn, confirmationSummaryScreen, error, password, confirmPassword, completedSteps, createPasswordSuccess, email, confirmEmail,
        steps, currentStep, existingCustomer, isBusy
    };
}

const connectedSignUpCreatePassword = connect(mapStateToProps)(SignUpCreatePassword);
export { connectedSignUpCreatePassword as SignUpCreatePassword };